import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { UsersState } from '../../models/users-state.model';

export const selectOrdersState = createFeatureSelector<UsersState>('users');

export const selectUsers = createSelector(
    selectOrdersState,
    (state: UsersState) => state.users
);

export const selectUser = createSelector(
    selectOrdersState,
    (state: UsersState) => state.user
);

export const selectIsLoading = createSelector(
    selectOrdersState,
    (state: UsersState) => state.isLoading
);

export const selectPagedUsers = createSelector(
    selectOrdersState,
    (state: UsersState) => state.users
);

export const selectTotalItems = createSelector(
    selectOrdersState,
    (state: UsersState) => state.totalItems
);

export const selectTotalPages = createSelector(
    selectOrdersState,
    (state: UsersState) => state.totalPages
);

export const selectCurrentUser = createSelector(
    selectOrdersState,
    (state: UsersState) => state.user
);

export const selectUserById = (id: number) => createSelector(
    selectOrdersState,
    (state: UsersState) => state.users.find(user => user.id === id)
);
